import { render, staticRenderFns } from "./FormCorreo.vue?vue&type=template&id=66fd2078&scoped=true"
import script from "./FormCorreo.vue?vue&type=script&lang=js"
export * from "./FormCorreo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fd2078",
  null
  
)

export default component.exports